export default "__VITE_ASSET__832e2008__"